var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortAsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3334 4.25C16.7476 4.25 17.0834 4.58579 17.0834 5L17.0834 16.6293L19.1394 14.5969C19.434 14.3057 19.9089 14.3085 20.2001 14.6031C20.4913 14.8976 20.4885 15.3725 20.1939 15.6637L16.8218 18.997C16.6705 19.1466 16.4717 19.2186 16.2746 19.2134C16.075 19.2184 15.8739 19.1441 15.7224 18.9909L12.3891 15.6187C12.0979 15.3242 12.1006 14.8493 12.3952 14.5581C12.6898 14.2669 13.1647 14.2697 13.4559 14.5642L15.5834 16.7165L15.5834 5C15.5834 4.58579 15.9192 4.25 16.3334 4.25Z",
    fill: "#8F95B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 5C4.25 4.58579 4.58579 4.25 5 4.25H7C7.41421 4.25 7.75 4.58579 7.75 5C7.75 5.41421 7.41421 5.75 7 5.75H5C4.58579 5.75 4.25 5.41421 4.25 5ZM4.25 12C4.25 11.5858 4.58579 11.25 5 11.25H8C8.41421 11.25 8.75 11.5858 8.75 12C8.75 12.4142 8.41421 12.75 8 12.75H5C4.58579 12.75 4.25 12.4142 4.25 12ZM5 18.25C4.58579 18.25 4.25 18.5858 4.25 19C4.25 19.4142 4.58579 19.75 5 19.75H10C10.4142 19.75 10.75 19.4142 10.75 19C10.75 18.5858 10.4142 18.25 10 18.25H5Z",
    fill: "#8F95B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAsc);
export default __webpack_public_path__ + "static/media/sort-asc.fc84915c75154145b1ba25e361b03d9a.svg";
export { ForwardRef as ReactComponent };